export default __webpack_public_path__ + "static/blob7-f5694b7c8b6aaf00dcc74f5da5945668.svg";